// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions} from '../duck';
import CheckoutConfig from '../checkout-config/CheckoutConfig';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(CheckoutConfig);
